export default __webpack_public_path__ + "static/avatar12-11731bc3c6f94e293f2cbd1844101699.png";